import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { PropsWithChildren, ReactNode } from 'react';
export const NumericBulletSection = t0 => {
  const $ = _c(21);
  const {
    bulletNumber,
    title,
    titleInfo,
    titleAction,
    gap: t1,
    children
  } = t0;
  const gap = t1 === undefined ? "40px" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: "4px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <Typography variant="h4">{title}</Typography>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3 || $[4] !== titleInfo) {
    t4 = <Stack direction="row" sx={t2}>{t3}{titleInfo}</Stack>;
    $[3] = t3;
    $[4] = titleInfo;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const heading = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      gap: "24px",
      alignItems: "start"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `${bulletNumber}.`;
  let t7;
  if ($[7] !== t6) {
    t7 = <Typography variant="h4">{t6}</Typography>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== gap) {
    t8 = {
      width: "100%",
      gap
    };
    $[9] = gap;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== heading || $[12] !== titleAction) {
    t9 = titleAction ? <Stack direction="row" sx={{
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px"
    }}>{heading}{titleAction}</Stack> : heading;
    $[11] = heading;
    $[12] = titleAction;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== children || $[15] !== t8 || $[16] !== t9) {
    t10 = <Stack sx={t8}>{t9}{children}</Stack>;
    $[14] = children;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <Stack direction="row" sx={t5}>{t7}{t10}</Stack>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};